import { Check } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/utils';

interface SuccessViewProps {
  inline: boolean;
  isMobile: boolean;
  onClose?: () => void;
  title?: string;
}

export const SuccessView: React.FC<SuccessViewProps> = ({
  inline,
  isMobile,
  onClose,
  title = 'Enrollment Successful!',
}) => {
  const successContent = (
    <div className="flex flex-col items-center justify-center text-center p-6">
      <div className="w-16 h-16 rounded-full bg-underwater-fern/20 flex items-center justify-center mb-4">
        <Check className="w-8 h-8 text-underwater-fern" />
      </div>
      <h3 id="success-title" className="text-xl font-bold text-white">
        {title}
      </h3>
    </div>
  );

  if (inline) {
    return (
      <div
        className="w-full overflow-hidden"
        role="group"
        aria-labelledby="success-title"
      >
        {successContent}
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        className={cn(
          'fixed inset-0 bg-black/50 z-(--z-bhanzu-buddy-modal-backdrop)',
          'transition-opacity duration-500 ease-out border-none p-0 cursor-default',
          'animate-in fade-in duration-500'
        )}
        onClick={onClose}
        aria-label="Close"
      />
      <div
        className={cn(
          'fixed z-(--z-bhanzu-buddy-modal) flex flex-col',
          'bg-magical-moonlight-d3 rounded-2xl overflow-hidden',
          'w-[98dvw] lg:w-full max-w-4xl',
          'h-auto max-h-[80vh]',
          'lg:mx-4 left-1/2 bottom-4 -translate-x-1/2',
          'animate-in slide-in-from-bottom-4 zoom-in-95 duration-500 ease-out origin-bottom',
          'shadow-2xl'
        )}
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-title"
      >
        <div
          className="flex flex-col items-center justify-center text-center p-6"
          style={{ minHeight: isMobile ? '61.4vh' : '640px' }}
        >
          {successContent}
        </div>
      </div>
    </>
  );
};
